module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0065.jpg?v=4eb17eee";